import { Spinner } from 'spin.js';

import 'spin.js/spin.css';

export default Spinner;